export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12015.d87b492c.jpg";